(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Transparent header logo switching on menu hover and sticky state
  document.addEventListener('DOMContentLoaded', function () {
    // Find the sticky-header element or header-wrapper (works for both transparent and non-transparent)
    const stickyHeader = document.querySelector('sticky-header.header-wrapper') || 
                         document.querySelector('.header-wrapper');
    if (!stickyHeader) return;

    const menuItems = stickyHeader.querySelectorAll('.header__menu-item');
    const menuContainer = stickyHeader.querySelector('.header__inline-menu');
    const logoWhite = stickyHeader.querySelector('.header__heading-logo--white');
    const logoBlack = stickyHeader.querySelector('.header__heading-logo--black');
    const sectionHeader = document.querySelector('.section-header');
    const isTransparent = stickyHeader.classList.contains('header-wrapper--transparent');

    // Only proceed with logo switching if header is transparent and logos exist
    if (isTransparent && (!logoWhite || !logoBlack)) return;

    // Function to check if header is sticky
    function isHeaderSticky() {
      return (
        sectionHeader &&
        (sectionHeader.classList.contains('shopify-section-header-sticky') ||
          sectionHeader.classList.contains('scrolled-past-header'))
      );
    }

    // Function to switch to black logo and add white background
    function switchToBlackLogo() {
      // Only work if header is transparent
      if (!isTransparent) return;
      // Don't override sticky state
      if (isHeaderSticky()) return;

      if (logoWhite) logoWhite.style.opacity = '0';
      if (logoBlack) logoBlack.style.opacity = '1';
      stickyHeader.classList.add('header-wrapper--menu-hover');
    }

    // Function to switch back to white logo and remove white background
    function switchToWhiteLogo() {
      // Only work if header is transparent
      if (!isTransparent) return;
      // Don't override sticky state
      if (isHeaderSticky()) return;

      if (logoWhite) logoWhite.style.opacity = '1';
      if (logoBlack) logoBlack.style.opacity = '0';
      stickyHeader.classList.remove('header-wrapper--menu-hover');
    }

    // Function to check if any mega menu is open
    function isMegaMenuOpen() {
      const menuDetails = stickyHeader.querySelectorAll('details.mega-menu');
      return Array.from(menuDetails).some(detail => detail.hasAttribute('open'));
    }

    // Handle hover on entire sticky-header element (only for transparent header)
    if (isTransparent) {
      stickyHeader.addEventListener('mouseenter', function (e) {
        // Only apply if header is transparent and not sticky
        if (!isHeaderSticky()) {
          switchToBlackLogo();
        }
      });

      stickyHeader.addEventListener('mouseleave', function (e) {
        // Check if mouse is moving to mega menu dropdown
        const megaMenu = stickyHeader.querySelector('.mega-menu__content');
        const isMovingToMegaMenu = megaMenu && megaMenu.contains(e.relatedTarget);
        
        // Don't remove class if mega menu is still open
        const megaMenuOpen = isMegaMenuOpen();

        if (!isMovingToMegaMenu && !megaMenuOpen && !isHeaderSticky()) {
          switchToWhiteLogo();
        }
      });
    }

    // Handle when mega menu details are opened/closed (only for transparent header)
    if (isTransparent) {
      const menuDetails = stickyHeader.querySelectorAll('details.mega-menu');
      menuDetails.forEach((detail) => {
        detail.addEventListener('toggle', function () {
          if (!isHeaderSticky()) {
            if (detail.open) {
              // Mega menu opened - apply white background
              switchToBlackLogo();
            } else {
              // Mega menu closed - check if still hovering over header or if another menu is open
              setTimeout(() => {
                const isHovering = stickyHeader.matches(':hover');
                const anyMenuOpen = isMegaMenuOpen();
                
                if (!isHovering && !anyMenuOpen) {
                  switchToWhiteLogo();
                }
              }, 100);
            }
          }
        });
      });
    }
  });

  // Hero Menu Hover Functionality - Works on all pages (not just transparent header)
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector("shop-user-avatar")) document.querySelector("shop-user-avatar").remove();

    function initHeroMenuHover() {
      const megaMenuContents = document.querySelectorAll('.mega-menu__content');
      
      megaMenuContents.forEach((megaMenuContent) => {
        const menuItemWrappers = megaMenuContent.querySelectorAll('.mega-menu__item-wrapper[data-hero-target]');
        const rightImageContainer = megaMenuContent.querySelector('.right_image');
        const leftMenu = megaMenuContent.querySelector('.Left_menu');
        
        if (!rightImageContainer || menuItemWrappers.length === 0) return;
        
        const heroSections = rightImageContainer.querySelectorAll('.hero-menu-section');
        // right_thirdLavelMenu is inside Left_menu, not right_image
        const rightThirdLevelMenuContainer = leftMenu ? leftMenu.querySelector('.right_thirdLavelMenu') : null;
        const thirdLevelMenuWrappers = rightThirdLevelMenuContainer ? rightThirdLevelMenuContainer.querySelectorAll('.third-level-menu-wrapper') : [];
        
        // Get current page URL for matching
        const currentPageUrl = window.location.pathname;
        
        // Hide all third-level menus initially
        thirdLevelMenuWrappers.forEach((wrapper) => {
          wrapper.classList.add('third-level-menu-wrapper--hidden');
        });
        
        // Hide all hero sections initially
        heroSections.forEach((section) => {
          section.classList.remove('hero-menu-section--visible');
          section.classList.add('hero-menu-section--hidden');
        });
        
        // Check if current page matches any menu item
        let currentPageMenuItem = null;
        let currentPageHeroSection = null;
        let currentPageIsThirdLevel = false;
        let currentPageThirdLevelMenu = null;
        let currentPageParentSecondLevel = null;
        
        // First check all menu items (both second and third level) for current page match
        menuItemWrappers.forEach((itemWrapper) => {
          const link = itemWrapper.querySelector('a.mega-menu__link');
          if (link) {
            const linkHref = link.getAttribute('href');
            // Remove trailing slash for comparison
            const normalizedLinkHref = linkHref ? linkHref.replace(/\/$/, '') : '';
            const normalizedCurrentUrl = currentPageUrl.replace(/\/$/, '');
            
            if (normalizedLinkHref === normalizedCurrentUrl) {
              currentPageMenuItem = itemWrapper;
              const heroTargetId = itemWrapper.getAttribute('data-hero-target');
              currentPageHeroSection = rightImageContainer.querySelector(`#${heroTargetId}`);
              
              // Check if this is a third-level item
              const isThirdLevel = itemWrapper.closest('.third_level');
              if (isThirdLevel) {
                currentPageIsThirdLevel = true;
                const thirdLevelMenu = itemWrapper.closest('.third-level-menu-wrapper');
                if (thirdLevelMenu) {
                  currentPageThirdLevelMenu = thirdLevelMenu;
                  
                  // Find parent second-level item
                  const parentHeroId = thirdLevelMenu.getAttribute('data-parent-target');
                  if (parentHeroId) {
                    currentPageParentSecondLevel = megaMenuContent.querySelector(`.mega-menu__item-wrapper[data-hero-target="${parentHeroId}"]`);
                  }
                }
              }
            }
          }
        });
        
        // Show first hero section by default if available (or current page hero if matched)
        const firstHeroSection = currentPageHeroSection || heroSections[0];
        let firstMenuItemWrapper = currentPageMenuItem || null;
        let firstThirdLevelItem = null;
        let firstThirdLevelMenu = currentPageThirdLevelMenu || null;
        
        if (firstHeroSection && !firstHeroSection.classList.contains('hero-menu-section--empty')) {
          firstHeroSection.classList.add('hero-menu-section--visible');
          firstHeroSection.classList.remove('hero-menu-section--hidden');
          
          // If current page matched, use that menu item, otherwise find the first one
          if (!firstMenuItemWrapper) {
            // Find and activate the first menu item wrapper by matching the hero section ID
            const firstHeroId = firstHeroSection.getAttribute('id');
            if (firstHeroId) {
              firstMenuItemWrapper = megaMenuContent.querySelector(`.mega-menu__item-wrapper[data-hero-target="${firstHeroId}"]`);
            }
          }
          
          if (firstMenuItemWrapper) {
            firstMenuItemWrapper.classList.add('mega-menu__item-wrapper--active');
            
            // Add active class to parent li if exists (for proper styling)
            const parentLi = firstMenuItemWrapper.closest('li');
            if (parentLi) {
              parentLi.classList.add('mega-menu__item-wrapper--active');
            }
            
            // Check if this second-level item has third-level menu using data-parent-target
            if (!firstThirdLevelMenu && rightThirdLevelMenuContainer) {
              const heroTargetId = firstMenuItemWrapper.getAttribute('data-hero-target');
              firstThirdLevelMenu = rightThirdLevelMenuContainer.querySelector(`.third-level-menu-wrapper[data-parent-target="${heroTargetId}"]`);
            }
            
            if (firstThirdLevelMenu) {
              // Show the third-level menu by removing hidden class
              firstThirdLevelMenu.classList.remove('third-level-menu-wrapper--hidden');
              
              // If current page is third level, show its hero
              if (currentPageIsThirdLevel && currentPageHeroSection && !currentPageHeroSection.classList.contains('hero-menu-section--empty')) {
                firstHeroSection.classList.remove('hero-menu-section--visible');
                firstHeroSection.classList.add('hero-menu-section--hidden');
                currentPageHeroSection.classList.remove('hero-menu-section--hidden');
                currentPageHeroSection.classList.add('hero-menu-section--visible');
                currentPageMenuItem.classList.add('mega-menu__item-wrapper--active');
                
                // Add active class to parent li
                const parentLi = currentPageMenuItem.closest('li');
                if (parentLi) {
                  parentLi.classList.add('mega-menu__item-wrapper--active');
                }
                
                // Also activate the parent second-level item
                if (currentPageParentSecondLevel) {
                  currentPageParentSecondLevel.classList.add('mega-menu__item-wrapper--active');
                  const parentLi2 = currentPageParentSecondLevel.closest('li');
                  if (parentLi2) {
                    parentLi2.classList.add('mega-menu__item-wrapper--active');
                  }
                }
              } else {
                // Get the first third-level item with a non-empty hero section
                const thirdLevelItems = firstThirdLevelMenu.querySelectorAll('.mega-menu__item-wrapper[data-hero-target]');
                
                // Find the first third-level item that has a non-empty hero section
                for (let i = 0; i < thirdLevelItems.length; i++) {
                  const item = thirdLevelItems[i];
                  const heroId = item.getAttribute('data-hero-target');
                  const hero = rightImageContainer.querySelector(`#${heroId}`);
                  
                  if (hero && !hero.classList.contains('hero-menu-section--empty')) {
                    firstThirdLevelItem = item;
                    
                    // Hide the second-level hero and show first third-level hero
                    firstHeroSection.classList.remove('hero-menu-section--visible');
                    firstHeroSection.classList.add('hero-menu-section--hidden');
                    hero.classList.remove('hero-menu-section--hidden');
                    hero.classList.add('hero-menu-section--visible');
                    firstThirdLevelItem.classList.add('mega-menu__item-wrapper--active');
                    
                    // Add active class to parent li
                    const parentLi = firstThirdLevelItem.closest('li');
                    if (parentLi) {
                      parentLi.classList.add('mega-menu__item-wrapper--active');
                    }
                    break;
                  }
                }
              }
            }
          }
        }
        
        // Handle hover on ALL second-level menu items
        menuItemWrappers.forEach((itemWrapper) => {
          const heroTargetId = itemWrapper.getAttribute('data-hero-target');
          const targetHeroSection = rightImageContainer.querySelector(`#${heroTargetId}`);
          
          // Check if this item is a third-level item (inside .third_level)
          const isThirdLevelItem = itemWrapper.closest('.third_level') !== null;
          
          // Skip third-level items here, they're handled separately
          if (isThirdLevelItem) return;
          
          // Find third-level menu using data-parent-target attribute
          // The third-level menus are in .right_thirdLavelMenu which is inside .Left_menu
          const thirdLevelMenu = rightThirdLevelMenuContainer ? rightThirdLevelMenuContainer.querySelector(`.third-level-menu-wrapper[data-parent-target="${heroTargetId}"]`) : null;
          
          itemWrapper.addEventListener('mouseenter', (e) => {
            // Hide all third-level menus first
            if (thirdLevelMenuWrappers.length > 0) {
              thirdLevelMenuWrappers.forEach((wrapper) => {
                wrapper.classList.add('third-level-menu-wrapper--hidden');
              });
            }
            
            // Show the associated third-level menu if it exists
            if (thirdLevelMenu) {
              // Remove hidden class to make it visible
              thirdLevelMenu.classList.remove('third-level-menu-wrapper--hidden');
              
              // Get third-level items for this menu
              const thirdLevelItems = thirdLevelMenu.querySelectorAll('.mega-menu__item-wrapper[data-hero-target]');
              
              // If there are third-level items, find the first one with a non-empty hero section
              if (thirdLevelItems.length > 0) {
                let firstThirdItem = null;
                let firstThirdHero = null;
                
                // Find the first third-level item that has a non-empty hero section
                for (let i = 0; i < thirdLevelItems.length; i++) {
                  const item = thirdLevelItems[i];
                  const heroId = item.getAttribute('data-hero-target');
                  const hero = rightImageContainer.querySelector(`#${heroId}`);
                  
                  if (hero && !hero.classList.contains('hero-menu-section--empty')) {
                    firstThirdItem = item;
                    firstThirdHero = hero;
                    break;
                  }
                }
                
                // Remove active class from all menu items (both second and third level)
                menuItemWrappers.forEach((wrapper) => {
                  wrapper.classList.remove('mega-menu__item-wrapper--active');
                  // Also remove from parent li
                  const parentLi = wrapper.closest('li');
                  if (parentLi) {
                    parentLi.classList.remove('mega-menu__item-wrapper--active');
                  }
                });
                
                // Remove active class from all third-level items in all menus
                if (rightThirdLevelMenuContainer) {
                  rightThirdLevelMenuContainer.querySelectorAll('.mega-menu__item-wrapper[data-hero-target]').forEach((wrapper) => {
                    wrapper.classList.remove('mega-menu__item-wrapper--active');
                    // Also remove from parent li
                    const parentLi = wrapper.closest('li');
                    if (parentLi) {
                      parentLi.classList.remove('mega-menu__item-wrapper--active');
                    }
                  });
                }
                
                // Hide all hero sections
                heroSections.forEach((section) => {
                  section.classList.remove('hero-menu-section--visible');
                  section.classList.add('hero-menu-section--hidden');
                });
                
                // Show the first non-empty third-level hero section and activate the item
                if (firstThirdHero && firstThirdItem) {
                  requestAnimationFrame(() => {
                    firstThirdHero.classList.remove('hero-menu-section--hidden');
                    firstThirdHero.classList.add('hero-menu-section--visible');
                    firstThirdItem.classList.add('mega-menu__item-wrapper--active');
                    // Add active to parent li
                    const parentLi = firstThirdItem.closest('li');
                    if (parentLi) {
                      parentLi.classList.add('mega-menu__item-wrapper--active');
                    }
                    
                    // Also activate the parent second-level item
                    itemWrapper.classList.add('mega-menu__item-wrapper--active');
                    const parentLi2 = itemWrapper.closest('li');
                    if (parentLi2) {
                      parentLi2.classList.add('mega-menu__item-wrapper--active');
                    }
                  });
                } else {
                  // If all third-level heroes are empty, show the second-level hero instead
                  if (targetHeroSection && !targetHeroSection.classList.contains('hero-menu-section--empty')) {
                    requestAnimationFrame(() => {
                      targetHeroSection.classList.remove('hero-menu-section--hidden');
                      targetHeroSection.classList.add('hero-menu-section--visible');
                      itemWrapper.classList.add('mega-menu__item-wrapper--active');
                      // Add active to parent li
                      const parentLi = itemWrapper.closest('li');
                      if (parentLi) {
                        parentLi.classList.add('mega-menu__item-wrapper--active');
                      }
                    });
                  }
                }
              } else {
                // No third-level items, show second-level hero
                if (targetHeroSection && !targetHeroSection.classList.contains('hero-menu-section--empty')) {
                  menuItemWrappers.forEach((wrapper) => {
                    wrapper.classList.remove('mega-menu__item-wrapper--active');
                    const parentLi = wrapper.closest('li');
                    if (parentLi) {
                      parentLi.classList.remove('mega-menu__item-wrapper--active');
                    }
                  });
                  heroSections.forEach((section) => {
                    section.classList.remove('hero-menu-section--visible');
                    section.classList.add('hero-menu-section--hidden');
                  });
                  requestAnimationFrame(() => {
                    targetHeroSection.classList.remove('hero-menu-section--hidden');
                    targetHeroSection.classList.add('hero-menu-section--visible');
                    itemWrapper.classList.add('mega-menu__item-wrapper--active');
                    const parentLi = itemWrapper.closest('li');
                    if (parentLi) {
                      parentLi.classList.add('mega-menu__item-wrapper--active');
                    }
                  });
                }
              }
            } else {
              // No third-level menu, show the second-level hero section
              if (targetHeroSection && !targetHeroSection.classList.contains('hero-menu-section--empty')) {
                // Remove active class from all menu items
                menuItemWrappers.forEach((wrapper) => {
                  wrapper.classList.remove('mega-menu__item-wrapper--active');
                  const parentLi = wrapper.closest('li');
                  if (parentLi) {
                    parentLi.classList.remove('mega-menu__item-wrapper--active');
                  }
                });
                
                // Hide all hero sections
                heroSections.forEach((section) => {
                  section.classList.remove('hero-menu-section--visible');
                  section.classList.add('hero-menu-section--hidden');
                });
                
                requestAnimationFrame(() => {
                  targetHeroSection.classList.remove('hero-menu-section--hidden');
                  targetHeroSection.classList.add('hero-menu-section--visible');
                  itemWrapper.classList.add('mega-menu__item-wrapper--active');
                  const parentLi = itemWrapper.closest('li');
                  if (parentLi) {
                    parentLi.classList.add('mega-menu__item-wrapper--active');
                  }
                });
              }
            }
          });
        });
        
        // Handle hover on menu items (both second and third level)
        menuItemWrappers.forEach((itemWrapper) => {
          const heroTargetId = itemWrapper.getAttribute('data-hero-target');
          const targetHeroSection = rightImageContainer.querySelector(`#${heroTargetId}`);
          
          if (!targetHeroSection) return;
          
          itemWrapper.addEventListener('mouseenter', () => {
            // Check if this is a third-level item
            const isThirdLevel = itemWrapper.closest('.third_level');
            
            if (isThirdLevel) {
              // This is a third-level item
              const thirdLevelMenu = itemWrapper.closest('.third-level-menu-wrapper');
              const allThirdLevelItems = thirdLevelMenu ? thirdLevelMenu.querySelectorAll('.mega-menu__item-wrapper[data-hero-target]') : [];
              
              // Find parent second-level item - handle both left menu (nested) and right menu cases
              let parentSecondLevelItem = null;
              
              if (thirdLevelMenu) {
                // Right menu third-level item - get parent from data-parent-target
                const parentHeroId = thirdLevelMenu.getAttribute('data-parent-target');
                parentSecondLevelItem = parentHeroId ? megaMenuContent.querySelector(`.mega-menu__item-wrapper[data-hero-target="${parentHeroId}"]`) : null;
              } else {
                // Left menu third-level item (nested) - find parent by traversing up the DOM
                // The third-level item is inside a <ul class="third_level">, which is inside a second-level <li>
                const thirdLevelUl = itemWrapper.closest('ul.third_level');
                if (thirdLevelUl) {
                  const secondLevelLi = thirdLevelUl.closest('li.mega-menu__item-wrapper');
                  if (secondLevelLi) {
                    parentSecondLevelItem = secondLevelLi;
                  }
                }
              }
              
              // Remove active class from all third-level items in this menu
              if (allThirdLevelItems.length > 0) {
                allThirdLevelItems.forEach((wrapper) => {
                  wrapper.classList.remove('mega-menu__item-wrapper--active');
                  const parentLi = wrapper.closest('li');
                  if (parentLi) {
                    parentLi.classList.remove('mega-menu__item-wrapper--active');
                  }
                });
              }
              
              // Remove active from all second-level items
              menuItemWrappers.forEach((wrapper) => {
                wrapper.classList.remove('mega-menu__item-wrapper--active');
                const parentLi = wrapper.closest('li');
                if (parentLi) {
                  parentLi.classList.remove('mega-menu__item-wrapper--active');
                }
              });
              
              // Hide all hero sections
              heroSections.forEach((section) => {
                section.classList.remove('hero-menu-section--visible');
                section.classList.add('hero-menu-section--hidden');
              });
              
              // Show the target hero section only if it's not empty
              if (targetHeroSection && !targetHeroSection.classList.contains('hero-menu-section--empty')) {
                requestAnimationFrame(() => {
                  targetHeroSection.classList.remove('hero-menu-section--hidden');
                  targetHeroSection.classList.add('hero-menu-section--visible');
                  itemWrapper.classList.add('mega-menu__item-wrapper--active');
                  
                  // Add active to parent li
                  const parentLi = itemWrapper.closest('li');
                  if (parentLi) {
                    parentLi.classList.add('mega-menu__item-wrapper--active');
                  }
                  
                  // Also activate the parent second-level item
                  if (parentSecondLevelItem) {
                    parentSecondLevelItem.classList.add('mega-menu__item-wrapper--active');
                    const parentLi2 = parentSecondLevelItem.closest('li');
                    if (parentLi2) {
                      parentLi2.classList.add('mega-menu__item-wrapper--active');
                    }
                  }
                });
              }
            } else {
              // This is a second-level item - check if it has third-level children using data-parent-target
              const hasThirdLevel = rightThirdLevelMenuContainer ? rightThirdLevelMenuContainer.querySelector(`.third-level-menu-wrapper[data-parent-target="${heroTargetId}"]`) : null;
              
              // Only handle if it doesn't have third-level children (those are handled by secondLevelItems handler)
              if (!hasThirdLevel) {
                // Hide all third-level menus
                thirdLevelMenuWrappers.forEach((wrapper) => {
                  wrapper.classList.add('third-level-menu-wrapper--hidden');
                });
                
                // Remove active class from all menu items
                menuItemWrappers.forEach((wrapper) => {
                  wrapper.classList.remove('mega-menu__item-wrapper--active');
                  const parentLi = wrapper.closest('li');
                  if (parentLi) {
                    parentLi.classList.remove('mega-menu__item-wrapper--active');
                  }
                });
                
                // Hide all hero sections
                heroSections.forEach((section) => {
                  section.classList.remove('hero-menu-section--visible');
                  section.classList.add('hero-menu-section--hidden');
                });
                
                // Show the target hero section
                if (!targetHeroSection.classList.contains('hero-menu-section--empty')) {
                  requestAnimationFrame(() => {
                    targetHeroSection.classList.remove('hero-menu-section--hidden');
                    targetHeroSection.classList.add('hero-menu-section--visible');
                    itemWrapper.classList.add('mega-menu__item-wrapper--active');
                    const parentLi = itemWrapper.closest('li');
                    if (parentLi) {
                      parentLi.classList.add('mega-menu__item-wrapper--active');
                    }
                  });
                }
              }
            }
          });
          
          itemWrapper.addEventListener('mouseleave', (e) => {
            // Only remove active class if mouse is not moving to another menu item or hero section
            const relatedTarget = e.relatedTarget;
            const isMovingToMenuItem = Array.from(menuItemWrappers).some(wrapper => 
              wrapper.contains(relatedTarget) || wrapper === relatedTarget
            );
            const isMovingToHeroSection = rightImageContainer && rightImageContainer.contains(relatedTarget);
            
            // Don't remove active class if moving to another menu item or hero section
            if (!isMovingToMenuItem && !isMovingToHeroSection) {
              // The active class will be managed by the megaMenuContent mouseleave handler
            }
          });
        });
        
        // Handle mouse leave on mega menu to show first hero section
        megaMenuContent.addEventListener('mouseleave', () => {
          // Hide all third-level menus first
          thirdLevelMenuWrappers.forEach((wrapper) => {
            wrapper.classList.add('third-level-menu-wrapper--hidden');
          });
          
          // Remove active class from all menu items
          menuItemWrappers.forEach((wrapper) => {
            wrapper.classList.remove('mega-menu__item-wrapper--active');
            const parentLi = wrapper.closest('li');
            if (parentLi) {
              parentLi.classList.remove('mega-menu__item-wrapper--active');
            }
          });

          heroSections.forEach((section) => {
            section.classList.remove('hero-menu-section--visible');
            section.classList.add('hero-menu-section--hidden');
          });
          
          if (firstHeroSection && !firstHeroSection.classList.contains('hero-menu-section--empty')) {
            requestAnimationFrame(() => {
              // Show first third-level menu and activate first third-level item if exists
              if (firstThirdLevelMenu) {
                // Show the third-level menu by removing hidden class
                firstThirdLevelMenu.classList.remove('third-level-menu-wrapper--hidden');
                
                // Find the first non-empty third-level hero section
                const thirdLevelItems = firstThirdLevelMenu.querySelectorAll('.mega-menu__item-wrapper[data-hero-target]');
                let foundNonEmptyHero = false;
                
                for (let i = 0; i < thirdLevelItems.length; i++) {
                  const item = thirdLevelItems[i];
                  const heroId = item.getAttribute('data-hero-target');
                  const hero = rightImageContainer.querySelector(`#${heroId}`);
                  
                  if (hero && !hero.classList.contains('hero-menu-section--empty')) {
                    firstHeroSection.classList.remove('hero-menu-section--visible');
                    firstHeroSection.classList.add('hero-menu-section--hidden');
                    hero.classList.remove('hero-menu-section--hidden');
                    hero.classList.add('hero-menu-section--visible');
                    item.classList.add('mega-menu__item-wrapper--active');
                    const parentLi = item.closest('li');
                    if (parentLi) {
                      parentLi.classList.add('mega-menu__item-wrapper--active');
                    }
                    
                    // Also activate the parent second-level item
                    if (firstMenuItemWrapper) {
                      firstMenuItemWrapper.classList.add('mega-menu__item-wrapper--active');
                      const parentLi2 = firstMenuItemWrapper.closest('li');
                      if (parentLi2) {
                        parentLi2.classList.add('mega-menu__item-wrapper--active');
                      }
                    }
                    
                    foundNonEmptyHero = true;
                    break;
                  }
                }
                
                // If no non-empty third-level hero found, show the second-level hero
                if (!foundNonEmptyHero) {
                  firstHeroSection.classList.remove('hero-menu-section--hidden');
                  firstHeroSection.classList.add('hero-menu-section--visible');
                  if (firstMenuItemWrapper) {
                    firstMenuItemWrapper.classList.add('mega-menu__item-wrapper--active');
                    const parentLi = firstMenuItemWrapper.closest('li');
                    if (parentLi) {
                      parentLi.classList.add('mega-menu__item-wrapper--active');
                    }
                  }
                }
              } else {
                // No third-level menu, show first hero section
                firstHeroSection.classList.remove('hero-menu-section--hidden');
                firstHeroSection.classList.add('hero-menu-section--visible');
                // Add active class back to first menu item
                if (firstMenuItemWrapper) {
                  firstMenuItemWrapper.classList.add('mega-menu__item-wrapper--active');
                  const parentLi = firstMenuItemWrapper.closest('li');
                  if (parentLi) {
                    parentLi.classList.add('mega-menu__item-wrapper--active');
                  }
                }
              }
            });
          }
        });
      });
    }
    
    // Initialize immediately since we're already in DOMContentLoaded
    initHeroMenuHover();
    
    // Re-initialize when mega menu opens (for dynamic content)
    const megaMenuDetails = document.querySelectorAll('details.mega-menu');
    megaMenuDetails.forEach((detail) => {
      detail.addEventListener('toggle', function() {
        if (detail.open) {
          setTimeout(initHeroMenuHover, 100);
        }
      });
    });
  });

  let items = document.querySelectorAll(".mega-menu");
  let header = document.querySelector("header");
  let currentItemIndex;
  let closeTimeouts = new Map();

  items.forEach((item, itemIndex) => {
    const content = item.querySelector(".mega-menu__content");
    let closeTimeout = null;

    const clearCloseTimeout = () => {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    };

    item.addEventListener("mouseenter", () => {
      clearCloseTimeout();
      
      // If switching from another menu, close it first
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex !== undefined && currentItemIndex !== itemIndex)
      ) {
        items[currentItemIndex].removeAttribute("open");
        // Minimal delay for smooth menu switching (premium feel)
        setTimeout(() => {
          currentItemIndex = itemIndex;
          item.setAttribute("open", true);
        }, 30);
      } else {
        currentItemIndex = itemIndex;
        // Ensure initial state is set before opening for smooth animation
        requestAnimationFrame(() => {
          item.setAttribute("open", true);
        });
      }
    });

    item.addEventListener("mouseleave", (event) => {
      // Check if mouse is moving to the content
      const relatedTarget = event.relatedTarget;
      if (content && content.contains(relatedTarget)) {
        return; // Don't close if moving to content
      }

      clearCloseTimeout();
      closeTimeout = setTimeout(() => {
        item.removeAttribute("open");
        closeTimeout = null;
      }, 300);
    });

    if (content) {
      content.addEventListener("mouseenter", () => {
        clearCloseTimeout();
      });

      content.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    }
  });

  const profileContainer = document.querySelector('.profile-container');
  const dropdownMenu = document.getElementById('dropdownMenu');
  let hoverTimeout;

  // Show dropdown on hover
  if (profileContainer && dropdownMenu) {
    profileContainer.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      dropdownMenu.classList.add('active');
      profileContainer.classList.add('active');
    });

    // Hide dropdown when mouse leaves (with small delay)
    profileContainer.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        dropdownMenu.classList.remove('active');
        profileContainer.classList.remove('active');
      }, 200);
    });

    // Handle menu item clicks
    const dropdownItems = document.querySelectorAll('.dropdown-item');
    dropdownItems.forEach(item => {
      item.addEventListener('click', () => {
        console.log('Clicked:', item.textContent);
        dropdownMenu.classList.remove('active');
        profileContainer.classList.remove('active');
        // Add your navigation logic here
      });
    });
  }

  // Select the link element
const discoverLink = document.querySelector('.hero-menu-button__link');

// Add click event listener
discoverLink.addEventListener('click', function(e) {
  // Prevent default link behavior
  e.preventDefault();
  
  // Get the URL from href attribute
  const url = this.getAttribute('href');
  
  // Check if target="_blank" exists
  const target = this.getAttribute('target');
  
  if (target === '_blank') {
    // Open in new tab
    window.open(url, '_blank');
  } else {
    // Redirect in same tab
    window.location.href = url;
  }
});

// Alternative: If you have multiple links with the same class
document.querySelectorAll('.hero-menu-button__link').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    
    const url = this.getAttribute('href');
    const target = this.getAttribute('target');
    
    if (target === '_blank') {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["programming-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery === 'undefined' || !$.fn.slick) {
      console.error('⚠️ Slick not loaded or jQuery missing');
      return;
    }

    const $main = $('.programming-slider__slides');
    const $thumbs = $('.programming-slider__thumbnails');

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.programming-slider__thumbnails',
      prevArrow: '<button type="button" class="slick-prev">‹</button>',
      nextArrow: '<button type="button" class="slick-next">›</button>',
    });

    $thumbs.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.programming-slider__slides',
      focusOnSelect: true,
      centerMode: false,
      arrows: false,
    });

    // Active thumbnail state
    $main.on('afterChange', function (event, slick, currentSlide) {
      $thumbs.find('.thumb').removeClass('active');
      $thumbs.find(`.thumb[data-index=${currentSlide}]`).addClass('active');
    });

    $thumbs.find('.thumb').on('click', function () {
      const index = $(this).data('index');
      $main.slick('slickGoTo', index);
    });

    // Set first thumb active
    $thumbs.find('.thumb[data-index=0]').addClass('active');
  });

  } catch(e) { console.error(e); }
})();
})();
